/**
 * System Service (No Public Routes Available)
 *
 * NOTE: All system routes require authentication according to the backend implementation.
 * This service is disabled for public access.
 *
 * Available system routes all have requireAuth: true:
 * - /system/health
 * - /system/connections
 * - /system/metrics
 * - /system/routes
 * - /system/config
 *
 * This service would only be useful in an authenticated context.
 */

export class SystemService {
  constructor(httpClient) {
    this.client = httpClient;
    this.path = '/system';
  }

  /**
   * All system endpoints require authentication and are not available for public access
   */
  _notAvailable() {
    throw new Error('System endpoints require authentication and are not available for public access');
  }

  async getHealth() { this._notAvailable(); }
  async getConnections() { this._notAvailable(); }
  async getMetrics() { this._notAvailable(); }
  async getRoutes() { this._notAvailable(); }
  async getConfig() { this._notAvailable(); }
  async getInfo() { this._notAvailable(); }
  async getLogs() { this._notAvailable(); }
  async clearCache() { this._notAvailable(); }
  async getCacheStatus() { this._notAvailable(); }
  async runDiagnostics() { this._notAvailable(); }
  async getPerformanceStats() { this._notAvailable(); }
  async restartServices() { this._notAvailable(); }
  async getEnvironment() { this._notAvailable(); }
  async getMigrationStatus() { this._notAvailable(); }
  async runMigrations() { this._notAvailable(); }
}